export default __webpack_public_path__ + "static/media/avatar_101.1b5c54a3.png";